import loadable from 'components/dynamic-import';

export const FloatingExtraTicketPromotion = loadable(() => import('./FloatingExtraTicketPromotion'));
export const ClaimExtraTicketModal = loadable(() => import('./ClaimExtraTicketModal'));
export { FloatingPromotion } from './FloatingPromotion';
